import { createSlice } from "@reduxjs/toolkit";



interface TradingPlayersState {
  tradingAwayPlayers: any[];
  tradingForPlayers: any[];
}

const initialState: TradingPlayersState = {
  tradingAwayPlayers: [],
  tradingForPlayers: [],
};

export const tradingPlayersSlice = createSlice({
  name: "tradingPlayers",
  initialState,
  reducers: {
    // Trading Away Players Actions
    addTradingAwayPlayer: (state, { payload }: { payload: any }) => {
      // Only add if we don't have 3 players already and player is not already in the list
      if (state.tradingAwayPlayers.length < 3) {
        const playerExists = state.tradingAwayPlayers.some(
          (player) => player.id === payload.id
        );
        if (!playerExists) {
          state.tradingAwayPlayers.push(payload);
        }
      }
    },
    removeTradingAwayPlayer: (state, { payload }: { payload: string }) => {
      state.tradingAwayPlayers = state.tradingAwayPlayers.filter(
        (player) => player.id !== payload
      );
    },
    clearTradingAwayPlayers: (state) => {
      state.tradingAwayPlayers = [];
    },
    setTradingAwayPlayers: (state, { payload }: { payload: any[] }) => {
      state.tradingAwayPlayers = payload.slice(0, 3); // Ensure max 3 players
    },

    // Trading For Players Actions
    addTradingForPlayer: (state, { payload }: { payload: any }) => {
      // Only add if we don't have 3 players already and player is not already in the list
      if (state.tradingForPlayers.length < 3) {
        const playerExists = state.tradingForPlayers.some(
          (player) => player.id === payload.id
        );
        if (!playerExists) {
          state.tradingForPlayers.push(payload);
        }
      }
    },
    removeTradingForPlayer: (state, { payload }: { payload: string }) => {
      state.tradingForPlayers = state.tradingForPlayers.filter(
        (player) => player.id !== payload
      );
    },
    clearTradingForPlayers: (state) => {
      state.tradingForPlayers = [];
    },
    setTradingForPlayers: (state, { payload }: { payload: any[] }) => {
      state.tradingForPlayers = payload.slice(0, 3); // Ensure max 3 players
    },

    // Clear All Trading Players
    clearAllTradingPlayers: (state) => {
      state.tradingAwayPlayers = [];
      state.tradingForPlayers = [];
    },

    // Swap Trading Players
    swapTradingPlayers: (state) => {
      const tempAwayPlayers = [...state.tradingAwayPlayers];
      state.tradingAwayPlayers = [...state.tradingForPlayers];
      state.tradingForPlayers = tempAwayPlayers;
    },
  },
});

export const {
  // Trading Away Players
  addTradingAwayPlayer,
  removeTradingAwayPlayer,
  clearTradingAwayPlayers,
  setTradingAwayPlayers,

  // Trading For Players
  addTradingForPlayer,
  removeTradingForPlayer,
  clearTradingForPlayers,
  setTradingForPlayers,

  // Clear All
  clearAllTradingPlayers,

  // Swap Players
  swapTradingPlayers,
} = tradingPlayersSlice.actions;

export default tradingPlayersSlice.reducer;
